import { CustomControl } from "./custom-control";

export class CustomSection{
  id:number = 0;
  groupName:string = '';
  name:string = '';
  controls:CustomControl[] = [];
};
